// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__l9uj8","info":"styles_info__8mAIy"};
module.exports.__checksum = "6b562031d706"